import React, { useRef, useEffect, useState } from 'react';
import { FaVolumeMute, FaVolumeUp } from 'react-icons/fa';
import './Video.css';
import covervideo2 from '../Video/covervideo2.mp4';

const videoRefs = []; // გლობალური მასივი ვიდეოს ref-ებისთვის

const VideoPlayer2 = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    if (!videoRefs.includes(videoRef)) {
      videoRefs.push(videoRef);
    }
  }, []); // მხოლოდ ერთხელ ეშვება

  const toggleMute = () => {
    if (!videoRefs[0]?.current) return; // თუ `current` არ არსებობს, ფუნქცია გაჩერდეს

    const newMuteState = !videoRefs[0].current.muted;
    setIsMuted(newMuteState);

    videoRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.muted = newMuteState;
      }
    });
  };

  useEffect(() => {
    if (videoRef.current) {
      const globalMuteState = videoRefs[0]?.current?.muted ?? true;
      videoRef.current.muted = globalMuteState;
      setIsMuted(globalMuteState);
    }
  }, []);

  return (
    <div className="video-container">
      <video ref={videoRef} src={covervideo2} loop autoPlay muted className="video" />
      <button onClick={toggleMute} className="mute-button">
        {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
      </button>
    </div>
  );
};

export default VideoPlayer2;